import { Box, Typography, Skeleton } from '@mui/material';
import React from 'react';
import usePractitionerControlsContext from '../../../../../../hooks/usePractitionerControlsContext/usePractitionerControlsContext';
import { MediaTypes } from '../../../../../../commands/practitioner/enums/MediaTypes';
import useMediaContext from '../../../../../../hooks/useMediaContextHook/useMediaContext';
import { PsylarisVideoItemStyle } from './style';
import { AppImage } from '../../../../../AppImage/AppImage';

interface PsylarisVideoItemProps {
  itemIndex: number;
  title: string;
  videoURL: string;
  imgCategoryUrl: string;
  onClickHandler: (idx: number) => void;
  detail: string;
  ThumbnailURL: string;
  stereoMode: string;
  selected: boolean;
}
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

export function PsylarisVideoItem(props: PsylarisVideoItemProps) {
  let { itemIndex, title, imgCategoryUrl, onClickHandler, videoURL, detail, ThumbnailURL, stereoMode, selected } =
    props;
  const { psylarisVideoItem } = PsylarisVideoItemStyle;
  const { setPractitionerMediaType } = usePractitionerControlsContext();
  const {
    setPsylarisDetailModal,
    setPsylarisDetailInfo,
    setDetailTitle,
    setDetailPreview,
    setSelectedItemURL,
    firstDiveInd,
    setFirstDiveInd,
    lastDiveIndex,
    isLoading,
    setOriginalMediaURL,
    setMediaPopperVideo,
  } = useMediaContext();

  const selectedItem = (index: number) => {
    if (!!videoURL) {
      // Generate a unique URL by appending a timestamp to force re-rendering
      const updatedURL = `${addWebToUrl(videoURL)}?t=${Date.now()}`;

      // Update the original media URL and selected item URL
      setOriginalMediaURL(addWebToUrl(videoURL)); // Set original URL without timestamp
      setSelectedItemURL(updatedURL); // Use timestamped URL to trigger re-render
      setPractitionerMediaType(MediaTypes.VIDEO);
      setMediaPopperVideo(true); // Ensure media playback is enabled
    }
  };

  const addWebToUrl = (url: string): string => {
    let index = url.lastIndexOf('.mp4');
    let newUrl = url.slice(0, index) + '_web' + url.slice(index);
    return newUrl;
  };

  const onMouseEnter = () => {
    if (!firstDiveInd && lastDiveIndex) {
      setDetailPreview(ThumbnailURL);
      setDetailTitle(title);
      setPsylarisDetailInfo(detail);
      setPsylarisDetailModal(true);
    }
    setFirstDiveInd(false);
  };

  const onMouseLeave = () => {
    setPsylarisDetailInfo('');
    setPsylarisDetailModal(false);
    setDetailPreview('');
    setDetailTitle('');
    setMediaPopperVideo(false);
  };

  return (
    <Box
      sx={psylarisVideoItem}
      onClick={(event) => onClickHandler(itemIndex)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`${selected ? 'selected' : ''}`}
      data-testid={`pwid-psylaris-item-${itemIndex}`}
    >
      <Box className={'category-item_image_container'} onClick={() => selectedItem(itemIndex)}>
        <AppImage className={'category-item_image'} src={imgCategoryUrl} isLoading={isLoading} />
      </Box>
      {!isLoading ? (
        <Box onClick={() => selectedItem(itemIndex)} className={'description-container description-container-title'}>
          <Typography className={'description'}>{title}</Typography>
        </Box>
      ) : (
        <Box className={'description-container'}>
          <Skeleton className={'description'} variant="text" sx={{ fontSize: '1rem', width: '50%' }} />
        </Box>
      )}
    </Box>
  );
}
